import React from "react"
import withContext from "utils/withContext"
import AdfoxAdaptive from "components/AdFoxAdaptive"

function getOptions(context) {
    if (context.device === "desktop") {
        return [
            {
                ownerId: 407082,
                containerId: "full-ir-1-pc",
                params: {
                    p1: "cxctp",
                    p2: "ibgh",
                    "partner-stat-id": context.analytics_lable
                }
            },
            ["tablet", "phone"],
            {
                tabletWidth: 830,
                phoneWidth: 480,
                isAutoReloads: true
            }
        ]
    }
    if (context.device === "mobile") {
        return [
            {
                ownerId: 407082,
                containerId: "full-ir-1-mob",
                params: {
                    p1: "daqjl",
                    p2: "itrx",
                    "partner-stat-id": context.analytics_lable
                }
            },
            ["tablet", "phone"],
            {
                tabletWidth: 830,
                phoneWidth: 480,
                isAutoReloads: true
            }
        ]
    }
}

export function AdfoxIR1_full({ context }) {
    const options = getOptions(context)
    if (!options) {
        return null
    }
    return (
        <AdfoxAdaptive
            options={ options }
        />
    )
}

export default withContext(AdfoxIR1_full)
